import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, DocUpload, DatePicker, PaperClip, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { UserIcon, CancelCircleIcon, CheckCircleIcon, EyeIcon, UploadIcon, PasswordActive, PasswordInactive } from 'assets/icons';
import moment from 'moment';
import { DriverService } from 'services';

interface Props extends RootState, RouteComponentProps<any> {
	dispatch: any
}

const STEPS = {
	DATA: 1,
	FILES: 2
}

const files = [
	{
		id: Constants.DOCUMENT_TYPES.MEDICAL_CERTIFICATE,
		name: 'Certificado de Salud',
		field: 'medical_certificate'
	},
	{
		id: Constants.DOCUMENT_TYPES.FOOD_HANDLING,
		name: 'Certificado de manipulación de alimentos',
		field: 'food_handling'
	},
	{
		id: Constants.DOCUMENT_TYPES.LICENSE,
		name: 'Licencia de conducir',
		field: 'license'
	},
	{
		id: Constants.DOCUMENT_TYPES.RIF,
		name: 'RIF',
		field: 'rif'
	},
	{
		id: Constants.DOCUMENT_TYPES.ID,
		name: 'Cédula',
		field: 'document_file'
	}
]

class Update extends React.Component<Props> {

	state: any = {
		form: {
			photo_file: null,
			name: '',
			password: '',
			birth_city: '',
			city: '',
			phone: '',
			gender: '',
			birthdate: '',
			document: '',
			email: '',
			owner: Constants.DRIVER_OWNER.NO,
			nationality_id: Constants.NATIONALITIES.V,
			working_since: '',
			medical_certificate: {
				expiration_date: '',
				file: ''
			},
			food_handling: {
				expiration_date: '',
				file: ''
			},
			license: {
				expiration_date: '',
				file: ''
			},
			rif: {
				expiration_date: '',
				file: ''
			},
			document_file: {
				expiration_date: '',
				file: ''
			}
		},
		activePassword: false,
		step: STEPS.DATA,
		nationalities: [],
		visible_image: false,
		file: null,
		driver: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Editar conductor',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await DriverService.view({
			driver_id: this.props.match.params.id
		});
		if (!res.driver && this.props.match.params?.id) {
			this.props.history.replace('/');
		}
		else if (res.driver) {
			const medical_certificate = res.driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.MEDICAL_CERTIFICATE);
			const food_handling = res.driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.FOOD_HANDLING);
			const document_file = res.driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.ID);
			const rif = res.driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.RIF);
			const license = res.driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.LICENSE);

			this.setState({
				visible: true,
				nationalities: res.nationalities || [],
				driver: res.driver,
				form: {
					...this.state.form,
					name: res.driver?.name || '',
					birth_city: res.driver?.birth_city || '',
					city: res.driver?.city || '',
					phone: res.driver?.phone || '',
					gender: res.driver?.gender || '',
					birthdate: res.driver?.birthdate ? moment(res.driver?.birthdate).toDate() : '',
					document: res.driver?.document || '',
					email: res.driver?.email || '',
					owner: res.driver?.owner || Constants.DRIVER_OWNER.NO,
					nationality_id: Constants.NATIONALITIES.V,
					working_since: res.driver?.working_since ? moment(res.driver?.working_since).toDate() : '',
					medical_certificate: {
						...this.state.form.medical_certificate,
						expiration_date: medical_certificate?.expiration_date ? moment(medical_certificate?.expiration_date).toDate() : ''
					},
					food_handling: {
						...this.state.form.food_handling,
						expiration_date: food_handling?.expiration_date ? moment(food_handling?.expiration_date).toDate() : ''
					},
					rif: {
						...this.state.form.rif,
						expiration_date: rif?.expiration_date ? moment(rif?.expiration_date).toDate() : ''
					},
					document_file: {
						...this.state.form.document_file,
						expiration_date: document_file?.expiration_date ? moment(document_file?.expiration_date).toDate() : ''
					},
					license: {
						...this.state.form.license,
						expiration_date: license?.expiration_date ? moment(license?.expiration_date).toDate() : ''
					}
				}
			});
		}
	}

	submit = async () => {
		await DriverService.save({
			...this.state.form,
			birthdate: this.state.form.birthdate && moment(this.state.form.birthdate).format('YYYY-MM-DD'),
			working_since: this.state.form.working_since && moment(this.state.form.working_since).format('YYYY-MM-DD'),
			driver_id: this.props.match.params.id,
			hasFile: true,
			// @ts-ignore
			medical_certificate: this.state.form?.medical_certificate?.file?.value,
			medical_certificate_expiration_date: this.state.form?.medical_certificate?.expiration_date && moment(this.state.form?.medical_certificate?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			rif: this.state.form?.rif?.file?.value,
			rif_expiration_date: this.state.form?.rif?.expiration_date && moment(this.state.form?.rif?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			food_handling: this.state.form?.food_handling?.file?.value,
			food_handling_expiration_date: this.state.form?.food_handling?.expiration_date && moment(this.state.form?.food_handling?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			license: this.state.form?.license?.file?.value,
			license_expiration_date: this.state.form?.license?.expiration_date && moment(this.state.form?.license?.expiration_date).format('YYYY-MM-DD'),
			// @ts-ignore
			document_file: this.state.form?.document_file?.file?.value,
			document_file_expiration_date: this.state.form?.document_file?.expiration_date && moment(this.state.form?.document_file?.expiration_date).format('YYYY-MM-DD'),
			user_id: this.props.user?.id,
			// @ts-ignore
			photo_file: this.state.form.photo_file?.value,
		});
		Globals.showSuccess("Se ha actualizado el conductor");
		this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers`);
	}

	next = async () => {
		const { step, form } = this.state;

		const filteredForm = Object.fromEntries(
		  Object.entries(form).filter(([key, value]) => typeof value !== 'object')
		);

		switch(step) {
			case STEPS.DATA:
				await DriverService.validate({
					...filteredForm,
					birthdate: this.state.form.birthdate && moment(this.state.form.birthdate).format('YYYY-MM-DD'),
					working_since: this.state.form.working_since && moment(this.state.form.working_since).format('YYYY-MM-DD'),
					driver_id: this.props.match.params.id
				});

				this.setState({ step: STEPS.FILES });
			break;

			case STEPS.FILES:
				this.submit();
			break;
		}
	}

	back = () => {
		const { step } = this.state;

		switch(step) {
			case STEPS.DATA:
				this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers`);
			break;

			case STEPS.FILES:
				this.setState({ step: STEPS.DATA });
			break;
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target?.name]: e.target?.value
			}
		});
	}

	viewFile = (item: any) => {
		if (typeof item === 'string') {
			if (item.endsWith('.pdf')) {
				window.open(item, '_blank');
			}
			else {
				this.setState({
					visible_image: true,
					file: item
				});
			}
		}
		else {
			if (item?.value?.type == 'application/pdf') {
				const url = URL.createObjectURL(item?.value);
				window.open(url, '_blank');
			}
			else {
				this.setState({
					visible_image: true,
					file: item?.dataURL
				});
			}
		}
	}

	onChangeFile = async (file: any, target: string) => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		let document_type_id = null;
		let ignore_document_expiration = false;

		switch(target) {
			case 'rif': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.RIF; 
				ignore_document_expiration = true;
			break;

			case 'food_handling': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.FOOD_HANDLING; 
				ignore_document_expiration = true;
			break;

			case 'medical_certificate': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_CERTIFICATE; 
			break;

			case 'document_file': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.ID; 
				ignore_document_expiration = true;
			break;
			
			case 'license': 
				document_type_id = Constants.BRAVEALO_DOCUMENT_TYPES.DRIVER_LICENSE; 
			break;
		}

		const res: any = await DriverService.readDocument({
			hasFile: true,
			photo: file.value,
			driver_id: this.props.match.params.id,
			document_type_id,
			ignore_document_expiration: ignore_document_expiration || ''
		});
		if (!res.result || !res.expiration_date) {
			this.setState({
				form: {
					...this.state.form,
					[target]: {
						...this.state.form[target],
						file: null
					}						
				}
			});
			return onError('El documento cargado no corresponde al formato requerido o no es válido. Por favor, sube el documento solicitado para continuar.');
		}
		else {
			this.setState({
				form: {
					...this.state.form,
					[target]: {
						...this.state.form[target],
						file,
						expiration_date: res.expiration_date ? moment(res.expiration_date).toDate() : ''
					}
				}
			});
		}
	}

	render() {
		const { step, form, visible_image, driver } = this.state;
		// @ts-ignore
		const photo_blob = form.photo_file ? URL.createObjectURL(form.photo_file?.value) : null;
		// @ts-ignore
		const photo_file = driver?.user_documents?.find((i: any) => i.document_type == Constants.DOCUMENT_TYPES.PHOTO)?.file;

		return (
			<div id="driver-update">
				<Viewer
			      visible={ visible_image }
			      onClose={ () => this.setState({ visible_image: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				{
					step == STEPS.DATA && (
						<>
							<div className="container-white">
								<div className="row">
									<div className="col-md-6">
										<div className="text-center" style={{ marginBottom: '20px' }}>
											<PaperClip
												className="btn-icon"
						                        value={''}
						                        onChange={(e: any) => {
						                        	this.setState({
						                              form: {
						                              	...this.state.form,
						                              	photo_file: e.target
						                              }
						                            });
						                        }}>
													<div className="photo-wrapper-file">
														<img
															// @ts-ignore
															src={form.photo_file ? photo_blob : (Constants.BASE_STORAGE + photo_file)}
														/>
													</div>
											</PaperClip>
										</div>

										<div className="input-group">
											<Input
												label="Nombre"
												value={form?.name}
												name="name"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
										<div className="input-group">
											<Select
												name="owner"
												label="Camión Propio"
												onChange={ (e: any) => this.change(e) }
												value={ form.owner }
												options={ [
													{ value: Constants.DRIVER_OWNER.YES.toString(), label: 'Si' },
													{ value: Constants.DRIVER_OWNER.NO.toString(), label: 'No' },
												] }
											/>
										</div>
										<div className="input-group" style={{ alignItems: 'center' }}>
											<Input
												type={ this.state.activePassword ? 'text' : 'password' }
												label={ this.props.match?.params?.id != null ? 'Cambiar contraseña (Opcional)' : `Contraseña` }
												value={form?.password}
												name="password"
												onChange={ (e: any) => this.change(e) }
												notMui
											/>
											<div className="input-group-prepend password-view" onClick={ () => {
												this.setState({
													activePassword: !this.state.activePassword
												});
											} }>
												<img src={ this.state.activePassword ? PasswordActive : PasswordInactive } />
											</div>
										</div>
										<div className="input-group">
											<DatePicker
					                          label="Trabajando desde el"
					                          placeholder="Fecha"
					                          maxDate={moment().toDate()}
					                          onChange={(date: string) => {
					                            this.setState({
					                              form: {
					                              	...this.state.form,
					                              	working_since: date
					                              }
					                            });
					                          }}
					                          value={form?.working_since}
					                        />
										</div>
										<div className="input-group">
											<Input
												type="number"
												label="Documento de Identidad"
												value={form?.document}
												name="document"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="input-group">
											<Input
												label="Email"
												value={form?.email}
												name="email"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
										<div className="input-group">
											<DatePicker
					                          label="Fecha de nacimiento"
					                          placeholder="Fecha"
					                          maxDate={moment().toDate()}
					                          onChange={(date: string) => {
					                            this.setState({
					                              form: {
					                              	...this.state.form,
					                              	birthdate: date
					                              }
					                            });
					                          }}
					                          value={form?.birthdate}
					                        />
										</div>
										<div className="input-group">
											<Select
												name="nationality_id"
												label="Nacionalidad"
												onChange={ (e: any) => this.change(e) }
												value={ form.nationality_id }
												options={ this.state.nationalities.map((item: any) => {
													return {
														value: item.id,
														label: item.name
													}
												}) }
											/>
										</div>
										<div className="input-group">
											<Input
												label="Lugar de Nacimiento"
												value={form?.birth_city}
												name="birth_city"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
										<div className="input-group">
											<Select
												label="Sexo"
												name="gender"
												onChange={ (e: any) => this.change(e) }
												value={ form.gender }
												options={ [
													{ value: 'M', label: 'Masculino' },
													{ value: 'F', label: 'Femenino' },
												] }
											/>
										</div>
										<div className="input-group">
											<Input
												type="number"
												maxLength={ 11 }
												label="Teléfono"
												value={form?.phone}
												name="phone"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
										<div className="input-group">
											<Input
												label="Zona donde reside"
												value={form?.city}
												name="city"
												onChange={(e: any) => this.change(e)}
												notMui
											/>
										</div>
									</div>
								</div>
							</div>

							<div className="text-right" style={{ maxWidth: '1000px', margin: '0 auto' }}>
								<div className="row row-buttons">
									<div className="col-md-6">
										<button className="btn" onClick={ () => this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers`) }>
											Atras
										</button>
									</div>
									<div className="col-md-6">
										<button className="btn btn-blue" onClick={ () => {
											this.next();
										} }>
											Continuar
										</button>
									</div>
								</div>
							</div>
						</>
					)
				}
				
				{
					step == STEPS.FILES && (
						<>
							<div className="container-white">
								<p className="title-documents">Documentos y certificaciones</p>
								<div className="row">
									{
										files?.map((item) => {
											const _file = driver?.user_documents?.find((i: any) => i.document_type == item?.id)?.file;

											return (
												<div className="col-md-6">
													<div className="document-item">
														<div className="row">
															<div className="col-md-8">
																<div className="container-title-document">
																	<p>{ item.name }</p>
																	<img className={ form[item.field].file || _file ? 'active' : '' } src={ form[item.field].file || _file ? CheckCircleIcon : CancelCircleIcon } />
																</div>
															</div>
															<div className="col-md-4">
																<PaperClip
																	className="btn-icon"
											                        successText="Adjuntar"
											                        pendingText="Adjuntar"
											                        value={''}
											                        formats={['png','jpg','pdf','jpeg']}
											                        onChange={(e: any) => {
											                        	this.onChangeFile(e.target,item.field);                   	
											                        }}>
											                        Adjuntar
																	<img src={ UploadIcon } />
											                    </PaperClip>
																<button className="btn btn-icon" disabled={ !this.state.form[item.field]?.file && !_file } onClick={ () => {
																	this.viewFile(this.state.form[item.field].file || (Constants.BASE_STORAGE + _file));
																} }>
																	Ver
																	<img src={ EyeIcon } />
																</button>
															</div>
														</div>

														<DatePicker
								                          label="F. Expiración"
								                          placeholder="--_--"
								                          minDate={moment().add(1,'day').toDate()}
								                          disabled={ true }
								                          onChange={(expiration_date: string) => {
								                            // this.setState({
								                            //   form: {
								                            //   	...this.state.form,
								                            //   	[item.field]: {
								                            //   		...this.state.form[item.field],
								                            //   		expiration_date
								                            //   	}
								                            //   }
								                            // });
								                          }}
								                          value={this.state.form[item.field].expiration_date}
								                        />
								                    </div>
												</div>
											)
										})
									}
								</div>
							</div>
							<div className="text-right" style={{ maxWidth: '1000px', margin: '0 auto' }}>
								<div className="row row-buttons">
									<div className="col-md-6">
										<button className="btn" onClick={ () => this.back() }>
											Atras
										</button>
									</div>
									<div className="col-md-6">
										<button className="btn btn-blue" onClick={ () => this.next() }>
											Guardar
										</button>
									</div>
								</div>
							</div>
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Update);